/**
 * Da la funcionalidad de a cualquier clase que la extienda para subir ficheros. Solo es necesario implementar uploadFile.
 * Para poder usar drag & drop es necesario usar la directiva dropFile
 * Para abrir el sistema de archivos, es necesario crear un input de tipo file u hacer click en él <input class="hidden" #fileInput (change)="onFileSelected($event)" type="file" />
 */
export abstract class MultiFileUploader {
    
    dragOverCounter = 0;
    isDragOver = false;
    
    abstract uploadFile(file: File);
    
    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        for(let i = 0; i < input.files.length; i++) {
            this.uploadFile(input.files.item(i));
        }
        input.value = '';
    }
    
    setDragOverCounter(value: number) {
        this.dragOverCounter = value;
        this.isDragOver = (this.dragOverCounter > 0);
    }
}